import React, { useState } from "react";
import { Button, StyledText } from "../../../../components/common";
import { CloseIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import NoticeImg from "./noticeImg.png";
import CautionIcon from "../../../../components/svgs/cautionIcon";
import ConfirmModal from "./ConfirmModal";
import NewUpdateReleaseTimer from "./NewUpdateReleaseTimer";

const NotificationModal = ({
  isOpen,
  onClose,
  featureTitle,
  featureMessage,
  featureButtonText,
  featureUrl,
  featureId,
  onDelete,
  releaseDate,
  releaseTime,
}) => {
  const { themeContext, theme } = useTheme();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isTime, setIsTime] = useState(false);

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <Divider onClick={onClose} />
        <Header>
          <CloseButton onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        </Header>
        <StyledText style={{ fontSize: 20 }}>{featureTitle}</StyledText>
        <IconContainer>
          <img src={NoticeImg} alt="STW" />
        </IconContainer>
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            paddingInline: 15,
          }}
        >
          {featureMessage}
        </StyledText>

        {!isTime && (
          <NewUpdateReleaseTimer
            releaseDate={releaseDate}
            releaseTime={releaseTime}
            onHandleIsTime={setIsTime}
          />
        )}

        <Button
          style={{
            border: "2px solid #b22525",
            width: "100%",
            marginBottom: "16px",
            cursor: "pointer",
          }}
          onClick={() => setShowConfirmModal(true)}
        >
          <StyledText color="#b22525">Delete notification</StyledText>
        </Button>

        {isTime && (
          <Button
            style={{
              backgroundColor: background,
              width: "100%",
              marginBottom: 0,
              cursor: "pointer",
            }}
            onClick={() => history.push(`${featureUrl}`)}
          >
            <StyledText color="white"> {featureButtonText}</StyledText>
          </Button>
        )}
      </ModalContent>

      {showConfirmModal && (
        <ConfirmModal
          isOpen={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
          title="Delete notification"
          message="Are you sure you want to delete this notification?"
          icon={
            <CautionIcon fill="white" stroke="#333" width="90" height="90" />
          }
          onConfirm={() => {
            onDelete(featureId);
            setShowConfirmModal(false);
            onClose();
          }}
        />
      )}
    </>
  );
};

export default NotificationModal;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const Divider = styled.div`
  width: 50px;
  height: 8px;
  background-color: #cbcbcb;
  border-radius: 10px;
  margin-top: 10px;
  cursor: pointer;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-bottom: 40px;
  img {
    width: 100px;
  }
`;

//! NEW ELEMENT ADDED

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;
